import { FormControl, FormGroup } from '@angular/forms';
import { DeviceBase } from './device-base';
import { PropertyMetadata } from '../../properties/property-types';
import { LevelDesignerElementBase } from '../element-base';
import { ParkingLevelElement } from '../parking/parkinglevel';
import { RegisterElement } from '../element-decorator';
import { Lane } from '../access-control/lane';
import { NetworkDeviceBase } from './network-device-base';

@RegisterElement()
export class Barrier extends NetworkDeviceBase {
    public override TypeName: string = "Barrier";
    protected override sizeInMeters: number = 4;
    public override ParentType: string | null = "Lane";
    public override ParentFormGroupName: string | null = "Barriers";

    constructor(formGroup: FormGroup) {
        super(formGroup, '/assets/icons/barrier.svg');
        
        if (!formGroup.contains('Type')) {
            formGroup.addControl('Type', new FormControl('mo24'));
        }
        if (!formGroup.contains('OpenDirection')) {
            formGroup.addControl('OpenDirection', new FormControl('Left'));
        }
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            ...super.getPropertyMetadata(),
            {
                formControlName: 'Type',
                displayName: 'Barrier Type',
                inputType: { 
                    type: 'select',
                    options: [
                        { value: 'mo24', label: 'ELKA Boom Gate' },
                        { value: 'froggatev1', label: 'Frog Gate' },
                        { value: 'tcp-kp-1202', label: '1202 Relay' }
                    ]
                },
                order: 7,
                category: 'Properties'
            },
            {
                formControlName: 'OpenDirection',
                displayName: 'Opening Direction',
                inputType: { 
                    type: 'select',
                    options: [
                        { value: 'Left', label: 'Left' },
                        { value: 'Right', label: 'Right' }
                    ]
                },
                order: 8,
                category: 'Properties'
            }
        ];
    }


    public override clone(): Barrier {
        return new Barrier(this.formGroup);
    }

    public override default(): Barrier {
        return this;
    }
} 
